import React, { useState } from 'react';
import { Star, Quote, Play, Maximize2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Avatar, AvatarFallback } from '../components/ui/avatar';
import { Dialog, DialogContent, DialogTrigger } from '../components/ui/dialog';
import { testimonials } from '../mock';

export const Testimonials = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videoTestimonials = [
    {
      id: 1,
      name: "Brenda",
      videoUrl: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/oyyzrmxv_Nex%20Level%20-%20Testimonio%20Brenda.mp4",
      poster: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/u46fh5hd_imagen_2026-07-14_103049858.png"
    },
    {
      id: 2,
      name: "Alejandro",
      videoUrl: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/qrf26k1a_Testimonio%20Alejandro%20%281%29.mp4",
      poster: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/51xkvxzp_Captura%20de%20pantalla%202026-07-14%20102101.png"
    },
    {
      id: 3,
      name: "Alejandra",
      videoUrl: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/c32xyb5n_Nex%20Level%20-%20Testimonio%20Alejandra%20%281%29.mp4",
      poster: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/2wh9tgab_Captura%20de%20pantalla%202026-07-14%20101956.png"
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="px-4 py-2 bg-gradient-to-r from-blue-600/20 to-sky-500/20 border border-sky-500/30 rounded-full text-sky-400 text-sm font-semibold backdrop-blur-sm inline-block mb-6 animate-bounce" style={{ animationDuration: '2s' }}>
            TESTIMONIOS
          </span>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in">
            <span className="bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
              Lo Que Dicen
            </span>
            <br />
            <span className="bg-gradient-to-r from-blue-400 to-sky-400 bg-clip-text text-transparent">
              Nuestros Miembros
            </span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Historias reales de transformación y éxito de nuestra comunidad NEX
          </p>
        </div>

        {/* Video Testimonials Section */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-blue-400 to-sky-400 bg-clip-text text-transparent">
                Video Testimonios
              </span>
            </h2>
            <p className="text-gray-400">Escucha directamente de nuestros miembros</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {videoTestimonials.map((video, index) => (
              <Dialog key={video.id}>
                <DialogTrigger asChild>
                  <Card
                    className="bg-gradient-to-br from-gray-900 to-black border-sky-500/20 hover:border-sky-500/50 transition-all duration-500 hover:scale-110 hover:shadow-2xl hover:shadow-sky-500/50 group animate-slide-up overflow-hidden cursor-pointer"
                    style={{ animationDelay: `${index * 0.15}s` }}
                  >
                    <CardContent className="p-0">
                      {/* Video Thumbnail */}
                      <div className="relative aspect-video bg-gradient-to-br from-gray-900 to-black group-hover:brightness-110 transition-all duration-300">
                        <img 
                          src={video.poster} 
                          alt={`Testimonio de ${video.name}`}
                          className="w-full h-full object-cover"
                        />
                        {/* Play overlay */}
                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/20 transition-all duration-300">
                          <div className="bg-gradient-to-r from-blue-600 to-sky-500 rounded-full p-6 transform group-hover:scale-125 transition-transform duration-300 shadow-2xl shadow-blue-500/50">
                            <Play className="h-10 w-10 text-white fill-white" />
                          </div>
                        </div>
                        {/* Maximize icon */}
                        <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <Maximize2 className="h-5 w-5 text-white" />
                        </div>
                      </div>

                      {/* Name and Info */}
                      <div className="p-6 text-center">
                        <div className="flex items-center justify-center space-x-2 mb-2">
                          <Play className="h-5 w-5 text-sky-400" />
                          <h3 className="text-xl font-bold text-white group-hover:text-sky-400 transition-colors duration-300">{video.name}</h3>
                        </div>
                        <p className="text-gray-400 text-sm mb-3">Testimonio de NEX Level</p>
                        
                        {/* Decorative stars */}
                        <div className="flex justify-center space-x-1">
                          {[...Array(5)].map((_, i) => (
                            <Star key={i} className="h-4 w-4 text-yellow-500 fill-yellow-500 group-hover:scale-110 transition-transform duration-300" style={{ transitionDelay: `${i * 50}ms` }} />
                          ))}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </DialogTrigger>

                {/* Fullscreen Video Modal */}
                <DialogContent className="max-w-6xl w-full bg-black/95 border-sky-500/30 p-2">
                  <div className="relative aspect-video bg-black rounded-lg overflow-hidden">
                    <video
                      controls
                      autoPlay
                      preload="auto"
                      playsInline
                      className="w-full h-full"
                    >
                      <source src={video.videoUrl} type="video/mp4" />
                      Tu navegador no soporta el reproductor de video.
                    </video>
                  </div>
                  <div className="text-center mt-4">
                    <h3 className="text-2xl font-bold text-white mb-2">Testimonio de {video.name}</h3>
                    <div className="flex justify-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="h-5 w-5 text-yellow-500 fill-yellow-500" />
                      ))}
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            ))}
          </div>
        </div>

        {/* Written Testimonials Section */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                Testimonios Escritos
              </span>
            </h2>
          </div>

          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto mb-16">
            {testimonials.map((testimonial, index) => (
              <Card
                key={testimonial.id}
                className="bg-gradient-to-br from-gray-900 to-black border-sky-500/20 hover:border-sky-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-sky-500/20 group relative overflow-hidden animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Quote Icon */}
                <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity duration-300">
                  <Quote className="h-16 w-16 text-sky-400" />
                </div>

                <CardContent className="p-6 relative z-10">
                  {/* Stars */}
                  <div className="flex space-x-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, index) => (
                      <Star key={index} className="h-5 w-5 text-yellow-500 fill-yellow-500" />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-gray-300 mb-6 leading-relaxed">"{testimonial.text}"</p>

                  {/* User Info */}
                  <div className="flex items-center space-x-4 pt-4 border-t border-sky-500/20">
                    <Avatar className="h-12 w-12 border-2 border-sky-500/50">
                      <AvatarFallback className="bg-gradient-to-br from-blue-600 to-sky-500 text-white font-bold">
                        {testimonial.avatar}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <h4 className="font-semibold text-white">{testimonial.name}</h4>
                      <p className="text-sm text-sky-400">{testimonial.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="max-w-5xl mx-auto mb-16">
          <Card className="bg-gradient-to-br from-gray-900 to-black border-sky-500/20 hover:scale-105 transition-transform duration-300">
            <CardContent className="p-12">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                <div>
                  <div className="text-5xl font-bold bg-gradient-to-r from-blue-400 to-sky-400 bg-clip-text text-transparent mb-2">
                    500+
                  </div>
                  <p className="text-gray-400 font-medium">Miembros Activos</p>
                </div>
                <div>
                  <div className="text-5xl font-bold bg-gradient-to-r from-blue-400 to-sky-400 bg-clip-text text-transparent mb-2">
                    98%
                  </div>
                  <p className="text-gray-400 font-medium">Satisfacción</p>
                </div>
                <div>
                  <div className="text-5xl font-bold bg-gradient-to-r from-blue-400 to-sky-400 bg-clip-text text-transparent mb-2">
                    4.9
                  </div>
                  <p className="text-gray-400 font-medium">Valoración Media</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* CTA */}
        <div className="text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Únete a Nuestra Comunidad
          </h3>
          <p className="text-gray-400 mb-8 text-lg">
            Empieza tu historia de transformación hoy
          </p>
          <button 
            className="bg-gradient-to-r from-blue-600 to-sky-500 hover:from-blue-700 hover:to-sky-600 text-white font-semibold px-10 py-4 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg shadow-blue-500/30 text-lg"
            onClick={() => window.open('https://wa.me/51939573726?text=Hola,%20estoy%20interesado', '_blank')}
          >
            Comienza Ahora
          </button>
        </div>
      </div>
    </div>
  );
};

